import React, { Component } from 'react'
import './styles.sass'

interface ToastProps {
  show: boolean,
  message: string,
  type?: 'info' | 'success' | 'warning' | 'error',
  onClose: () => void,
  autoClose?: boolean,
  duration?: number
}

interface ToastState {
  visible: boolean,
  animate: boolean
}

export default class Toast extends Component<ToastProps, ToastState> {
  private timeoutId: NodeJS.Timeout | null = null

  state: ToastState = {
    visible: false,
    animate: false
  }

  componentDidMount() {
    if (this.props.show) {
      this.showToast()
    }
  }

  componentDidUpdate(prevProps: ToastProps) {
    if (prevProps.show !== this.props.show) {
      if (this.props.show) {
        this.showToast()
      } else {
        this.hideToast()
      }
    }
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  showToast = () => {
    this.setState({ visible: true })
    setTimeout(() => {
      this.setState({ animate: true })
    }, 10)

    // Auto close se especificado (padrão: true com 5 segundos)
    if (this.props.autoClose !== false) {
      const duration = this.props.duration || 5000
      this.timeoutId = setTimeout(() => {
        this.hideToast()
      }, duration)
    }
  }

  hideToast = () => {
    this.setState({ animate: false })
    setTimeout(() => {
      this.setState({ visible: false })
      this.props.onClose()
    }, 300)
  }

  render() {
    if (!this.state.visible) return null

    const toastClass = `toast toast-${this.props.type || 'info'} ${this.state.animate ? 'show' : ''}`

    return (
      <div className={toastClass}>
        <div className="toast-content">
          <span className="toast-message">{this.props.message}</span>
          <button className="toast-close" onClick={this.hideToast}>×</button>
        </div>
      </div>
    )
  }
}
